<template>
    <div>
        <v-dialog
            v-model="dialog"
            max-width="600"
            content-class="spillard-dialog-devices-bulk"
        >
            <v-card>
                <div class="close" @click="dialog = !dialog">
                    <i class="material-icons">close</i>
                </div>
                <div class="info-block">
                    Upload multiple devices
                </div>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    v-if="!uploadedResponse"
                >

                    <v-container fluid>
                        <v-layout row>
                            <v-flex md12>
                                <div class="dropBox">
                                    <div class="drop-info">
                                        <div class="drop-image">
                                            <img src="@/assets/images/icon-drop-here.png" alt="" />
                                        </div>
                                        <div class="drop-text">
                                            Drop CSV file here or click to select
                                        </div>
                                        <div class="drop-input">
                                            <input type="file" class="file" @change="addFiles" />
                                            <sp-button sp-class="no-padding-right" small-icon icon="arrow-left" text="Drop file to upload them"></sp-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="error--text drop-error" v-if="dropped && form.file == null">You must upload one file.</div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <div class="add-devices">
                                <div v-if="form.file != null" class="file-list">
                                    <div class="file-list__file"
                                         :key="`file_${form.file.name}_${form.file.lastModified}`">
                                        <img src="@/assets/icons/icon-file-csv.svg" width="16">
                                        {{ form.file.name }}
                                        <button class="remove-file" @click="clearFile">
                                            <i class="material-icons">close</i>
                                        </button>
                                    </div>
                                </div>
                                <div class="add-devices__buttons">
                                    <sp-button @click.native="getTemplate" sp-class="no-padding-right" icon="download" text="Download template"></sp-button>
                                    <sp-button @click.native="uploadDevices" sp-class="no-padding-right" icon="add" text="Add devices"></sp-button>
                                </div>
                            </div>
                        </v-layout>
                    </v-container>
                </v-form>

                <div class="uploaded-devices" v-if="uploadedResponse">
                    <v-data-table
                        :headers="[
                            {text: 'Line', value: 'position'},
                            {text: 'Hardware Id', value: 'hardwareId'},
                            {text: 'Error Message', value: 'message', sortable: false}
                        ]"
                        :items="fileErrors"
                        hide-default-footer
                        hide-actions
                    >
                        <template v-slot:items="props">
                            <td>{{props.item.position}}</td>
                            <td>{{props.item.hardwareId}}</td>
                            <td>{{props.item.message}}</td>
                        </template>
                    </v-data-table>

                    <div class="uploaded-devices__button">
                        <sp-button @click.native="resetDialog" sp-class="no-padding-right" small-icon icon="arrow-left" text="Upload new file"></sp-button>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import toast from '@/plugins/izitoast'
import DeviceApi from '@/api/DeviceApi'

const deviceApi = new DeviceApi()

export default {
    name: 'DevicesBulkUploadDialog',
    components: {
        SpButton
    },
    mounted () {
        document.querySelector('.spillard-dialog-devices-bulk').addEventListener('dragleave', ev => {
            this.dropzone = false
        })

        document.querySelector('.spillard-dialog-devices-bulk').addEventListener('dragover', ev => {
            ev.preventDefault()
            ev.stopPropagation()

            this.dropzone = true
        })

        document.querySelector('.spillard-dialog-devices-bulk').addEventListener('drop', ev => {
            ev.preventDefault()
            ev.stopPropagation()

            this.dropped = true
            this.previewFiles(ev.dataTransfer.files)
        })
    },
    data () {
        return {
            dialog: false,
            valid: false,
            dropped: false,
            dropzone: false,
            filesCounter: 0,
            form: {
                file: null
            },
            allowedExtensions: [
                'text/csv'
            ],
            uploadedResponse: null
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
        fileErrors () {
            if (null == this.uploadedResponse) return null
            return this.uploadedResponse.details.map(item => {
                let message = item.message
                switch (item.message) {
                    case 'incomplete_row':
                        message = 'Incomplete row'
                        break
                    case 'hardware_id_is_empty':
                        message = 'Hardware ID field is empty'
                        break
                    case 'too_long_hardware_id':
                        message = 'Too long Hardware ID'
                        break
                    case 'data_to_capture_is_empty':
                        message = 'Device data to capture field is empty'
                        break
                    case 'invalid_value_data_to_capture':
                        message = 'Invalid value in data to capture field'
                        break
                    case 'channels_is_empty':
                        message = 'Channels field is empty'
                        break
                    case 'invalid_value_channels':
                        message = 'Invalid value in channels field'
                        break
                    case 'model_is_empty':
                        message = 'Device model field is empty'
                        break
                    case 'invalid_value_model':
                        message = 'Invalid value in device model field'
                        break
                    case 'protocol_is_empty':
                        message = 'Device protocol field is empty'
                        break
                    case 'invalid_value_protocol':
                        message = 'Invalid value in device protocol field'
                        break
                    case 'device_enabled_is_empty':
                        message = 'Device enabled field is empty'
                        break
                    case 'invalid_value_device_enabled':
                        message = 'Invalid value in device enabled field'
                        break
                    case 'too_long_sim_number':
                        message = 'Sim number is too long'
                        break
                    case 'too_long_serial_number':
                        message = 'Serial number is too long'
                        break
                    case 'too_long_firmvare_version':
                        message = 'Firmware version is too long'
                        break
                }

                return {
                    position: item.position,
                    hardwareId: item.hardwareId,
                    message: message
                }
            })
        }
    },
    watch: {
        value: {
            handler () {
                this.dialog = this.value
            }
        },
        dialog (val) {
            if (!val) {
                this.resetDialog()

                this.$refs.form.resetValidation()
            }
            this.$emit('input', val)
        }
    },
    methods: {
        addFiles (event) {
            this.dropped = true
            this.previewFiles(event.target.files)
        },
        previewFiles (files) {
            let self = this
            if (1 < files.length) {
                toast.error('You can upload only one file.')
                return
            }
            if (!this.allowedExtensions.includes(files[0].type)) {
                toast.error(files[0].type + ' type is not allowed.')
                this.dropped = false
                this.form.file = null
                return
            }
            self.form.file = files[0]
        },
        resetDialog () {
            this.valid = false
            this.dropped = false
            this.dropzone = false
            this.filesCounter = 0
            this.form = {
                file: null
            }
            this.uploadedResponse = null
        },
        clearFile () {
            this.form = {
                file: null
            }
        },
        async uploadDevices () {
            this.dropped = true
            this.valid = this.$refs.form.validate()
            if (!this.valid || null == this.form.file) {
                return false
            }

            let data = new FormData()

            data.append('file', this.form.file)
            const response = await deviceApi.importDevices(data)

            if (!response.isSuccess) {
                toast.error('An error occured while creating devices.')
                return
            }

            if (!response.payload.message) {
                this.dialog = false
                toast.success('Devices added successfully.')
                return false
            } else {
                this.uploadedResponse = response.payload
                toast.error('Errors found in CSV file.')
            }
        },
        async getTemplate () {
            const response = await deviceApi.getTemplate()

            if (!response.isSuccess) return

            let blob = new Blob([response.payload], { type: 'text/cvs;charset=utf-8;' })
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, 'Devices_import_template.csv')
            } else {
                var link = document.createElement('a')
                if (link.download !== undefined) {
                    var url = URL.createObjectURL(blob)
                    link.setAttribute('href', url)
                    link.setAttribute('download', 'Devices_import_template.csv')
                    link.style.visibility = 'hidden'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-block {
    margin-bottom: 0;
}

.dropBox {
    border: 3px solid $gray;
    padding: 30px 15px;
    background: $white;
    min-height: 100px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .drop-image {
        text-align: center;
    }

    .drop-text {
        text-align: center;
        font-size: 22px;
    }

    .drop-input {
        position: relative;
        margin-top: 10px;
        display: flex;
        justify-content: center;

        .file {
            position: absolute;
            z-index: 9;
            opacity: 0;
        }
    }

    .images {
        width: 100%;
        .image-box {
            display: inline-block;
            width: 200px;
            height: 150px;
            margin: 10px;

            img {
                position: relative;
                max-width: 100%;
                max-height: 100%;
                transform: translateY(-50%);
                top: 50%;
            }
        }
    }
}

.drop-error {
    font-size: 12px;
    margin-top: 5px;
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
.add-devices {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    width: 100%;

    &__buttons {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 15px;
    }
}

.file-list {
    margin-right: auto;
    &__file {
        display: flex;
        align-items: center;

        img {
            margin-right: 10px;
        }
    }
    .remove-file {
        display: inline-flex;
        align-items: center;
    }
}

.uploaded-devices {
    padding: 20px;
    display: flex;
    flex-direction: column;

    &__button {
        margin: 15px 0 0 auto;
    }
}
</style>
